// src/components/modals/XpErrorModal.jsx
import React from 'react';
import { X } from 'lucide-react';
import Mascot from '../Mascot';

export default function XpErrorModal({ 
  errorData, 
  onClose, 
  currentSkin, 
  zIndex 
}) {
  if (!errorData) return null;

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in" 
      style={{ zIndex }}
    >
      <div className="bg-white rounded-[2.5rem] p-6 w-full max-w-sm text-center shadow-2xl animate-in zoom-in-95 duration-200 border-4 border-indigo-100 relative mt-10">
        
        {/* Mascota superior (Posición unificada con Chest y Reward) */}
        <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-32 h-32 pointer-events-none">
          <Mascot type={currentSkin} />
        </div>

        <div className="mt-12 space-y-4">
          <h3 className="text-2xl font-black text-slate-700 leading-tight">
            {errorData.title}
          </h3>

          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-200">
            <p className="text-sm font-black text-slate-700 leading-relaxed">
              {errorData.message}
            </p>
            {errorData.missingXp > 0 && (
              <p className="text-xs font-bold text-slate-400 mt-2 uppercase tracking-widest">
                Te faltan {errorData.missingXp} XP
              </p>
            )}
          </div>

          <button 
            onClick={onClose} 
            className="w-full py-3 rounded-2xl font-black text-white bg-slate-800 hover:bg-slate-700 transition-colors border-b-4 border-slate-900 active:border-b-0 active:translate-y-1"
          >
            ENTENDIDO
          </button>
        </div>

        {/* Botón de cierre rápido */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 p-2 bg-slate-100 rounded-full text-slate-400 hover:text-slate-600 transition-colors"
          aria-label="Cerrar"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}